import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../../../config";
import AuthContext from "../../../../context/AuthContext";
import styles from "./styles/OperativeParameters.module.scss";

const OperativeParameters = ({ selectedBoilerRoom }) => {
  const { authTokens } = useContext(AuthContext);
  const [boilerRooms, setBoilerRooms] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Загрузка параметров котельных
  const fetchOperativeParameters = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/TControl/dynamic_settings/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authTokens.access}`,
        },
      });
      const data = await response.json();
      setBoilerRooms(data);
    } catch (error) {
      console.error("Ошибка при загрузке данных по котельным:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBoilerRoom) {
      fetchOperativeParameters();
    }
  }, [selectedBoilerRoom]);

  // Фильтрация и сортировка данных только для выбранной котельной
  const filteredBoilerRooms = selectedBoilerRoom
    ? boilerRooms
        .filter((boiler) => boiler.boilerhouse_id === selectedBoilerRoom.pk)
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    : [];

  // Проверка на утечки
  const boilerRoomsWithLeakage = filteredBoilerRooms.map((boiler, index, array) => {
    if (index === array.length - 1) {
      return { ...boiler, leakageMessage: "Нет" };
    }

    const nextBoiler = array[index + 1];
    const hasLeakage =
      (nextBoiler.p1 > boiler.p1 * 1.1) ||
      (nextBoiler.p2 > boiler.p2 * 1.1) ||
      (nextBoiler.p3 > boiler.p3 * 1.1) ||
      (nextBoiler.p4 > boiler.p4 * 1.1);

    return {
      ...boiler,
      leakageMessage: hasLeakage ? "Внимание утечка!" : "Нет",
    };
  });

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Оперативные параметры
      </h2>

      {isLoading ? (
        <div className={styles.loading}>Загрузка данных...</div>
      ) : (
        <>
          {selectedBoilerRoom && boilerRoomsWithLeakage.length > 0 ? (
            <table className={styles.table}>
              <thead>
                <tr>
                  <th rowSpan="2" className={styles.tableHeader}>Дата</th>
                  <th rowSpan="2" className={styles.tableHeader}>Время</th>
                  <th colSpan="1" className={styles.tableHeader}>Давление воды на вводе</th>
                  <th colSpan="4" className={styles.tableHeader}>Теплоноситель</th>
                  {selectedBoilerRoom.gvs_activity && (
                    <th colSpan="4" className={styles.tableHeader}>ГВС</th>
                  )}
                  <th colSpan="1" className={styles.tableHeader}>Давление газа на вводе</th>
                  <th rowSpan="2" className={styles.tableHeader}>Наличие утечек</th>
                </tr>
                <tr>
                  <th className={styles.tableHeader}>Рвх</th>
                  <th className={styles.tableHeader}>Т1</th>
                  <th className={styles.tableHeader}>Р1</th>
                  <th className={styles.tableHeader}>Т2</th>
                  <th className={styles.tableHeader}>Р2</th>
                  {selectedBoilerRoom.gvs_activity && (
                    <>
                      <th className={styles.tableHeader}>Т3</th>
                      <th className={styles.tableHeader}>Р3</th>
                      <th className={styles.tableHeader}>Т4</th>
                      <th className={styles.tableHeader}>Р4</th>
                    </>
                  )}
                  <th className={styles.tableHeader}>Ргаз</th>
                </tr>
              </thead>
              <tbody>
                {boilerRoomsWithLeakage.map((boiler, index) => {
                  const createdAt = new Date(boiler.created_at);
                  const date = createdAt.toLocaleDateString("ru-RU");
                  const time = createdAt.toLocaleTimeString("ru-RU", {
                    hour: '2-digit',
                    minute: '2-digit'
                  });

                  return (
                    <tr key={index} className={styles.tableRow}>
                      <td className={styles.tableCell}>{date}</td>
                      <td className={styles.tableCell}>{time}</td>
                      <td className={styles.tableCell}>{boiler.pressure}</td>
                      <td className={styles.tableCell}>{boiler.t1}</td>
                      <td className={styles.tableCell}>{boiler.p1}</td>
                      <td className={styles.tableCell}>{boiler.t2}</td>
                      <td className={styles.tableCell}>{boiler.p2}</td>
                      {selectedBoilerRoom.gvs_activity && (
                        <>
                          <td className={styles.tableCell}>{boiler.t3}</td>
                          <td className={styles.tableCell}>{boiler.p3}</td>
                          <td className={styles.tableCell}>{boiler.t4}</td>
                          <td className={styles.tableCell}>{boiler.p4}</td>
                        </>
                      )}
                      <td className={styles.tableCell}>{boiler.gas}</td>
                      <td className={styles.tableCell}>
                        <span className={boiler.leakageMessage === "Внимание утечка!" ? styles.leakageWarning : ''}>
                          {boiler.leakageMessage}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div className={styles.noData}>Нет данных для отображения</div>
          )}
        </>
      )}
    </div>
  );
};

export default OperativeParameters;